const websiteH5Home = resolve => {
    require.ensure(['@/views/websiteH5/home.vue'],
        () => {
            resolve(require('@/views/websiteH5/home.vue'))
        })
}
const websiteH5About = resolve => {
    require.ensure(['@/views/websiteH5/about.vue'],
        () => {
            resolve(require('@/views/websiteH5/about.vue'))
        })
}
const websiteH5Recruit = resolve => {
    require.ensure(['@/views/websiteH5/recruit.vue'],
        () => {
            resolve(require('@/views/websiteH5/recruit.vue'))
        })
}
const websiteH5Questions = resolve => {
    require.ensure(['@/views/websiteH5/questions.vue'],
        () => {
            resolve(require('@/views/websiteH5/questions.vue'))
        })
}
const websiteH5Community = resolve => {
    require.ensure(['@/views/websiteH5/community.vue'],
        () => {
            resolve(require('@/views/websiteH5/community.vue'))
        })
}




const roustes = [
    {
        path: '/h5',
        name: 'websiteH5Home',
        component: websiteH5Home,
        meta: {
            title: "小保书-优质保险老师对接平台！"
        }
    },
    {
        path: '/h5/about',
        name: 'websiteH5About',
        component: websiteH5About,
        meta: {
            title: "小保书-优质保险老师对接平台！"
        }
    },
    {
        path: '/h5/recruit',
        name: 'websiteH5Recruit',
        component: websiteH5Recruit,
        meta: {
            title: "小保书-优质保险老师对接平台！"
        }
    },
    {
        path: '/h5/questions',
        name: 'websiteH5Questions',
        component: websiteH5Questions,
        meta: {
            title: "小保书-优质保险老师对接平台！"
        }
    },
    // 小保书社区
    {
        path: '/h5/community',
        name: 'websiteH5Community',
        component: websiteH5Community,
        meta: {
            title: "小保书-优质保险老师对接平台！"
        }
    },


]




export default roustes


// WEBPACK FOOTER //
// ./src/router/websiteh5.js